import { Env } from "../../../index";
import { ProvidersCatalog } from "../../classes/provider/Provider";
import plutioProviderProd from "./prod/plutio";
import airtableProviderProd from "./prod/airtable";
import dropboxProviderProd from "./prod/dropbox";
import githubProviderProd from "./prod/github";
import googleDriveProviderProd from "./prod/googleDrive";
import googleProviderProd from "./prod/google";

const prodProviders = new ProvidersCatalog({
        providers: [
                plutioProviderProd,
                airtableProviderProd,
                dropboxProviderProd,
                githubProviderProd,
                googleDriveProviderProd,
                googleProviderProd,
        ],
});

const providers = (env: Env) => {
        switch (env) {
                case Env.STAGE:
                        return prodProviders;
                default:
                        return prodProviders;
        }
};

export { providers };
